import { Meeting } from "features/Resources/Meeting/models";
import { useSkipByPrefixId } from "features/Resources/Shared/hooks";
import ButtonWithConfirm from "components/Button/ButtonWithConfirm";
import { useQueryClient } from "@tanstack/react-query";
import { meetingKeys } from "../../hooks";
import { Text14 } from "components/Text";
import { titleize } from "helpers/string";
import { lowerCase } from "lodash";

const CONFIRM_SKIP_ARGS = (title: string) => ({
  header: `Confirm ${titleize(title)} Meeting`,
  body: `Are you sure you want to ${lowerCase(title)} this Meeting?`,
  confirmButtonText: "Yes",
});

interface SkipMeetingButtonProps {
  meeting: Meeting;
  children?: (title: string) => React.ReactNode;
}

export default function SkipMeetingButton({ meeting, children }: SkipMeetingButtonProps) {
  const { mutate: skipMeeting } = useSkipByPrefixId(meeting?.prefixId);
  const queryClient = useQueryClient();

  if (!meeting) return null;

  const title = meeting.status === "skipped" ? "Unskip" : "Skip"
  return (
    <ButtonWithConfirm
      tooltipLabel={children ? undefined : title}
      {...CONFIRM_SKIP_ARGS(title)}
      intent="confirmation"
      handleConfirm={() => skipMeeting(
        undefined,
        { onSuccess: () => queryClient.invalidateQueries({ queryKey: meetingKeys.all }) },
      )}
    >
      {children ? children(title) : <Text14>{title}</Text14>}
    </ButtonWithConfirm>
  );
}
